import PropTypes from "prop-types";
import * as React from "react";
import { ACCEPTED_TYPES } from "../../domain/shopImageEditor";
import { Button } from "../../themeV2";

export default function FilePicker({
  inputLabel,
  children,
  multiple = false,
  onFiles,
  variant = "tonal",
  leading,
}) {
  const inputRef = React.useRef(null);

  const handleChange = (event) => {
    const files = [...event.target.files];
    inputRef.current.value = "";
    if (files.length > 0) onFiles(files);
  };

  return (
    <>
      <Button
        variant={variant}
        leading={leading}
        onClick={() => inputRef.current?.click()}
      >
        {children}
      </Button>
      <input
        ref={inputRef}
        type="file"
        accept={ACCEPTED_TYPES.join(",")}
        multiple={multiple}
        hidden
        aria-label={inputLabel}
        onChange={handleChange}
      />
    </>
  );
}

FilePicker.propTypes = {
  inputLabel: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  multiple: PropTypes.bool,
  onFiles: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(["filled", "tonal", "text"]),
  leading: PropTypes.node,
};
